// extracted by mini-css-extract-plugin
module.exports = {"actionButtonsContainer":"ReferralSources_actionButtonsContainer__1gw_4","actionColumn":"ReferralSources_actionColumn__1iHya","textButton":"ReferralSources_textButton__3_aK4"};